//
//
//
//
//
//

import FeedBookWechat from './components/own_writer/feed_book_wechat.vue'
export default {
  name: 'App',
  components: {
    FeedBookWechat
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    // console.dir()
  }
}
